import _ from 'lodash'
import Button from '@mui/material/Button'
import Spinner from 'react-bootstrap/Spinner';
import React, { useEffect, useState } from 'react'
import { Form, Image, Alert } from 'react-bootstrap'
import configuration from '../../utils/configuration'
import { useDispatch, useSelector } from 'react-redux'

import MessageView from './MessageView'
import { isModel } from '../../helpers/storage/user'
import ChatWindowAttachment from './ChatWindowAttachment'
import { ChatWindowHeaderDesktop } from './ChatWindowHeader'
import SubscribedContentModal from './SubscribedContentModal'
import QuillEditor from '../../components/helper/QuillEditor';
import { ChatroomStatusEnum } from '../../helpers/constants/message'
import { isSubscribedToStart } from '../../store/actions/SubscriptionPaymentAction'
import { fetchChatMessageStart, sendMessageSetInputData } from '../../store/actions/ChatAction'

import './style_new.scss'

const ChatWindow = ({
  member,
  setProgress,
  blockChatroom,
  onSendMessage,
  isLoading,
  setShowReport,
  getUserStatus,
  isSidebarClass,
  setShowProgress,
  unblockChatroom,
  setChatroomVisible,
  setChatroomInvisible,
  muteChatroomNotification,
  unmuteChatroomNotification,
  setShowDeleteConverstaionConfirmation
}) => {
  const dispatch = useDispatch()
  const [subscribeShow, setSubscribeShow] = useState(false)
  const {
    inputData: { assets, text, price },
  } = useSelector((state) => state.chat.sendMessage)
  const messages = useSelector(state => state.chat.messages)
  const [paymentNoticeShow, setPaymentNoticeShow] = useState(false)
  const chatroom = useSelector(state => state.chat.activeConversation.chatroom)
  const isSubscribedTo = useSelector((state) => state.subscriptionsPayment.isSubscribedTo)
  const profile = useSelector((state) => state.users.profile);
  
  const submitBtn = React.useRef()

  useEffect(() => {
    if (member) {
      dispatch(isSubscribedToStart(member?.unique_id))
    }
  }, [member])

  useEffect(() => {
    const shouldShow = shouldShowPaymentNotice();
    setPaymentNoticeShow(shouldShow);

    if (shouldShow) {
      const timeoutId = setTimeout(() => {
        setPaymentNoticeShow(false);
      }, 5000);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [isSubscribedTo, profile]);

  const onTextChange = (e) => {
    dispatch(
      sendMessageSetInputData({
        text: e.target.value
      })
    )
  }

  const onPriceChange = (e) => {
    dispatch(
      sendMessageSetInputData({
        price: e.target.value
      })
    )
  }

  const onSubmit = (e) => {
    e.preventDefault();

    const messageAssets = assets.map((item) => item.url);
    const isSent = onSendMessage(
      text,
      messageAssets,
      price
    );

    if (!isSent) {
      return;
    }

    const newMessage = {
      text,
      assets: messageAssets,
      price,
    };

    dispatch(
      fetchChatMessageStart({
        chatroom_id: chatroom?.id,
        messages: [...getChatroomMessages(), newMessage],
      })
    );

    dispatch(
      sendMessageSetInputData({
        text: '',
        price: '',
        assets: [],
      })
    );
  };
  

  const getChatroomLoading = () => {
    return messages.data ? messages.data[chatroom?.id]?.loading : false
  }

  const getChatroomMessages = () => {
    return messages.data ? messages.data[chatroom?.id]?.messages : []
  }

  const handleNextMessages = () => {
    dispatch(
      fetchChatMessageStart({
        chatroom_id: chatroom?.id,
        page: messages.data[chatroom?.id]?.page + 1,
      })
    )
  }

  const onMediaAttachment = (payload) => {
    dispatch(
      sendMessageSetInputData({
        assets: [...assets, ...payload]
      })
    )
  }

  const isActive = () => {
    return chatroom?.status === ChatroomStatusEnum.Active && !member?.deleted_at
  }

  const shouldShowPaymentNotice = () => {
    if (isModel() || (profile.loading || profile.data?.allow_free_message)) return false
    if (!member || member?.allow_receiving_free_message) return false
    if (_.isEmpty(isSubscribedTo.data)) return true
    return isSubscribedTo.data.performer_id !== member.id
  }

  const hasNext = () => {
    return messages.data[chatroom?.id]?.page < messages.data[chatroom?.id]?.numberOfPages
  }

  const removeFile = (index) => {
    dispatch(
      sendMessageSetInputData({
        text,
        price,
        assets: assets.filter((_, i) => i !== index),
      })
    )
  }

  const getMessagePriceLimit = () => {
    const limit = configuration.get('configData.chatroom_message_lock_payment_limit')
    return limit || 0
  };

  return (
    <>
      <div className="chatwindowopen chatconversation">
        <ChatWindowHeaderDesktop 
          member={member}
          chatroom={chatroom}
          setShowReport={setShowReport}
          blockChatroom={blockChatroom}
          getUserStatus={getUserStatus}
          isSidebarClass={isSidebarClass}
          unblockChatroom={unblockChatroom}
          setChatroomVisible={setChatroomVisible}
          setChatroomInvisible={setChatroomInvisible}
          muteChatroomNotification={muteChatroomNotification}
          unmuteChatroomNotification={unmuteChatroomNotification}
          setShowDeleteConverstaionConfirmation={setShowDeleteConverstaionConfirmation} />
        <div className="messageboxchat">
          <div className="messagesent">
            <ul className="messagesendin">
              {messages.loading && hasNext() && (
                <div id="top-scroll" style={{ textAlign: 'center', padding: 15 }}>
                  Loading....
                </div>
              )}
              <MessageView
                hasNext={hasNext()}
                loading={getChatroomLoading()}
                messages={getChatroomMessages()}
                handleNextMessages={handleNextMessages}
              />
            </ul>
          </div>
          {!member?.deleted_at && paymentNoticeShow && (
            <Alert variant="danger" className="not_verify_suggest non_subscribed_user_alert position-fixed">
              <div className="row">
                <div className="col-sm-11">
                  Please be aware that if you are not subscribed to the performer then there will be a rate of $
                  {configuration.get('configData.chatroom_message_payment_amount')} per message charged for any messages that you send to
                  remove this fee navigate to the performer's profile and subscribe.
                </div>
                <div className="col-sm-1">
                  <Button
                    variant="primary"
                    className="btn-sm pull-right"
                    type="button"
                    onClick={() => setPaymentNoticeShow(false)}
                    title='close'
                  >
                    <i className="fas fa-times"></i>
                  </Button>
                </div>
              </div>
            </Alert>
          )}
        </div>
      </div>
      {subscribeShow && <SubscribedContentModal setSubscribeShow={setSubscribeShow} />}
      <div className="bottomchatwindow chatconversation">
        {assets.length > 0 && (
          <div className="attachments-list">
            <div className='attachments-list-header'>
              <h5>Attachments</h5>
            </div>
            <hr/>
            {assets.map((item, index) => (
              <div key={`file-${index}`} className="attachments-list-item align-items-center">
                <p className="col-10 col-md-11 mb-0">
                <a href={item.url} target="blank" aria-label={item.name}>
                  {item.name}
                </a>
                </p>
                <button className="btn float-right col-2 col-md-1" onClick={() => removeFile(index)} title='close'>
                  <i className="fas fa-times"></i>
                </button>
              </div>
            ))}
            <hr/>
            <div className="price-input mt-3">
              <label>Price (Optional)</label>
              <div className="input-group mb-3 pt-2">
                <div className="input-group-prepend">
                  <span className="input-group-text">$</span>
                </div>
                <input
                  min="1"
                  name="key"
                  type="number"
                  value={price}
                  pattern="[0-9]*"
                  placeholder={`Add price to lock message ${getMessagePriceLimit() ?  `(Max $${getMessagePriceLimit()})` : ''}`}
                  onChange={onPriceChange}
                  className="form-control price"
                />
              </div>
            </div>
          </div>
        )}
        {member?.deleted_at && (
          <Alert variant="danger" className="mt-1 not_verify_suggest">
            <div className="row">
              <div className="col-sm-11">This account is inactive!</div>
            </div>
          </Alert>
        )}
        <Form className="senditempart" onSubmit={onSubmit} translate='no'>
          <Form.Group className="d-flex align-items-start" controlId="formSearch">
            {isModel() && (
              <ChatWindowAttachment
                isActive={isActive()}
                chatroom={chatroom?.id}
                setProgress={setProgress}
                setShowProgress={setShowProgress}
                onMediaAttachment={onMediaAttachment}
              />
            )}
            <QuillEditor
              className='message-window flex-grow-1 overflow-y-hidden'
              id={`message-editor`}
              placeholder='Type your message here'
              value={text}
              onChange={(val) => onTextChange({
                target: {
                  value: val
                }
              })}
              handleSubmit={() => {
                submitBtn.current.click()
              }}
              readOnly={!isActive()}
            />

            <Button ref={submitBtn} type="submit" className="primary btn btn-primary sendbtn" disabled={!isActive() || isLoading}>
             {
                isLoading ? (
                  <Spinner
                    animation="border"
                    size="md"
                    role="status"
                    aria-hidden="true"
                    variant="dark"
                  />
                ) : (
                  <Image src="https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/arrow-icons_send.svg" round alt='arrow icon' />
                )
              }
            </Button>
          </Form.Group>
        </Form>
      </div>
    </>
  )
}

export default ChatWindow
